import Api from '@/common/fetch.js'
import { apiRoute } from '@/common/config'

let guestRoute = apiRoute + '/Guest'

export default {
    getGuests (request) {
        return Api.post(guestRoute, request)
    },
    addGuest (request) {
        return Api.post(guestRoute + '/Add', request)
    },
    editGuest (request) {
        return Api.post(guestRoute + '/Edit', request)
    },
    deleteGuest (request) {
        return Api.post(guestRoute + '/Delete', request)
    },
    getMail (request) {
        return Api.post(guestRoute + '/GetDefaultMailBody', request)
    },
    send (request) {
        return Api.post(guestRoute + '/SendInvitation', request)
    },
    fetchCard (request) {
        return Api.post(guestRoute + '/FetchCard', request)
    },
    closeGuest (request) {
        return Api.post(guestRoute + '/CloseGuest', request)
    }
}
